export function headerSearch() {

    function searchInit(selector) {
        const searchBlock = document.querySelector(selector);

        if (!searchBlock) {
            return false;
        }

        const searchOpen = searchBlock.querySelector('.js-searchOpen');
        const searchWrapper = searchBlock.querySelector('.js-searchWrapper');
        const searchInner = searchBlock.querySelector('.js-searchInner');
        const searchInput = searchBlock.querySelector('.js-searchInput');
        const searchResultCounter = searchBlock.querySelector('.js-searchResultCounter');
        const searchList = searchBlock.querySelector('.js-searchList');
        const searchForm = searchBlock.querySelector('.js-searchForm');

        const headerNav = document.querySelector('.js-headerNav');

        if (searchOpen) {
                searchOpen.addEventListener('click', function() {
                    searchWrapper.classList.add('is-active');
                    headerNav.classList.add('is-invisible');
                    searchInput.focus();
                });
        }

        searchInput.addEventListener('input', function() {
            searchList.innerHTML = '';

            if (searchInput.value.length > 0) {
                searchInner.classList.add('is-active');
                searchWrapper.classList.add('is-active-state2');
            } else {
                searchInner.classList.remove('is-active');
                searchWrapper.classList.remove('is-active-state2');
            }

            fetch('/search?query=' + encodeURIComponent(searchInput.value) + '&limit=5', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            })
            .then(response => response.json())
            .then(r => {
                // удаляем старые варианты
                while (searchList.lastElementChild) {
                    searchList.removeChild(searchList.lastElementChild);
                }

                try {
                    // результаты поиска
                    r.data.search_results.forEach(function(item) {
                        searchList.insertAdjacentHTML('beforeend',
                            `<a class="header_search-item" href="${item.url}">${item.title}</a>`
                        );
                    });

                    // количество результатов
                    searchResultCounter.textContent = r.data.search_results_count;
                } catch (e) {
                    // количество результатов
                    searchResultCounter.textContent = 0;
                }
            });
        });

        searchForm.addEventListener('submit', function(e) {
            e.preventDefault()
            window.location.href = '/search?query=' + encodeURIComponent(searchInput.value);
        })

        document.addEventListener('click', function(e) {
            if (!e.target.closest('.js-searchBlock')) {
                searchWrapper.classList.remove('is-active');
                searchInner.classList.remove('is-active');
                searchWrapper.classList.remove('is-active-state2');
                headerNav.classList.remove('is-invisible');
                searchInput.value = '';
            }
        });
    }

    function adaptive(script) {
        script();

        ['resize', 'orientationChange'].forEach( function(item) {
            window.addEventListener(item, script);
        });
    }

    adaptive(function () {
        searchInit('.js-searchBlock');
        searchInit('.js-searchBlockMob');
    });

}
